import CallLog from '@/services/api/call-log';

export default {
  namespaced: true,
  state: {
    callLogClient: [],
  },
  getters: {
    callLogClient: state => state.callLogClient,
  },
  mutations: {
    setCallLogClient: (state, payload) => {
      state.callLogClient = payload;
    },
  },
  actions: {
    getCallLogClient (state, { id, options = {} }) {
      return new Promise((resolve, reject) => {
        CallLog.getCallLogClient(id, options)
          .then(({ data }) => {
            state.commit('setCallLogClient', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
  },
};
